import React from 'react';
import styled from 'styled-components/macro';
import { RouteComponentProps } from 'react-router-dom';
import { findIndex } from 'ramda';

import { TabBar, TabItem } from '@deeptrue-frontend/ui';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import { useFormatMessage } from 'components/IntlProvider';

const StyledTabItem = styled(TabItem)``;

const TabBarWrapper = styled.div`
  margin: 1.5rem 0 2rem;
  width: 100%;
`;

const { withRouter, ROUTES } = RouterProvider;

const urls = [
  ROUTES.ORGANIZATION.ADMIN.USERS,
  ROUTES.ORGANIZATION.ADMIN.GROUPS,
  ROUTES.ORGANIZATION.ADMIN.PROJECTS,
  ROUTES.ORGANIZATION.ADMIN.PRODUCTS,
];

const checkPathname = (pathname: string) => {
  const itemIndex = findIndex((url: string) => new RegExp(url).test(pathname))(
    urls
  );

  return itemIndex || 0;
};

const Menu = ({ location, history }: RouteComponentProps) => {
  const t = useFormatMessage();
  return (
    <TabBarWrapper>
      <TabBar
        selectedIndex={checkPathname(location.pathname)}
        onSelect={(value: number) => history.push(urls[value])}
      >
        <StyledTabItem title={t('organization.users', 'Users')} />
        <StyledTabItem title={t('organization.groups', 'Groups')} />
        <StyledTabItem title={t('organization.projects', 'Projects')} />
        <StyledTabItem title={t('organization.products', 'Products')} />
      </TabBar>
    </TabBarWrapper>
  );
};

export default withRouter(Menu);
